<template>
  <div class="wph-increment-input wph-relative">
    <input type="text" :id="inputId" class="wph-form-group__control"
           ref="input" :value="value"
           v-on="inputListeners"
    >
    <button type="button" @click="decrement"
            class="wph-increment-input__decrement
                   wph-absolute wph-right-0 wph-bottom-0
                   wph-block wph-w-6 wph-h-1/2
                   wph-text-xl wph-leading-none wph-text-gray-500
                   hover:wph-bg-gray-300 focus:wph-outline-none"
    >-</button>
    <button type="button" @click="increment"
            class="wph-increment-input__increment
                   wph-absolute wph-right-0 wph-top-0
                   wph-block wph-w-6 wph-h-1/2
                   wph-leading-none wph-text-gray-500
                   hover:wph-bg-gray-300 focus:wph-outline-none"
    >+</button>
  </div>
</template>

<script>
export default {
  name: "IncrementInput",
  props: {
    value: { type: Number, required: true },
    step: { type: Number, default: 1 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 1000000 },
    inputId: { type: String },
    decimalPlaces: { type: Number, default: 0 },
  },
  watch: {
    value: {
      handler() {
        if (this.$refs.input.value !== this.value) {
          this.$refs.input.value = this.value
        }
      },
      immdeiate: true,
    }
  },
  computed: {
    inputListeners() {
      const _this = this
      return Object.assign({}, this.$listeners, {
        input(e) {
          const val = e.target.value ? parseFloat(e.target.value) : 0
          if (isNaN(val)) {
            _this.$emit('input', _this.value)
          }
          let result = +val.toFixed(_this.decimalPlaces)
          if (result > _this.max) {
            result = _this.max
          } else if (result < _this.min) {
            result = _this.min
          }
          _this.$emit('input', result)
        },
        blur(e) {
          if (+(e.target.value) !== _this.value) {
            e.target.value = _this.value
          }
        },
      })
    },
  },
  methods: {
    increment() {
      const newVal = +(this.value + this.step).toFixed(this.decimalPlaces)
      this.$emit('input', newVal > this.max ? this.max : newVal)
    },
    decrement() {
      const newVal = +(this.value - this.step).toFixed(this.decimalPlaces)
      this.$emit('input', newVal < this.min ? this.min : newVal)
    },
    focusInput() {
      const _this = this
      this.$nextTick(() => {
        _this.$refs.input.focus()
      })
    }
  }
}
</script>
